/**
 * Created by Jaime Bonilla Venegas on 2017-06-19.
 *
 */
import React, { Component } from 'react';
import { FlatButton, TextField, RefreshIndicator } from 'material-ui';
import { login, setToken, onSuccess, validCreedentials } from '../../security';

class Login extends Component {

    constructor() {
        super();
        this.state = {
            username: null,
            password: null,
            loading: false,
            error: ''
        };
    }

    login() {
        const { username, password } = this.state;
        if (!validCreedentials(username, password)) {
            this.setState({ error: 'Se requiere usuario y contraseña' });
            return;
        }
        this.setState({ loading: true, error: '' });
        login(username, password)
            .then(({ token }) => {
                setToken(token);
                onSuccess();
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: 'Usuario y/o contraseña incorrectos...'
                });
            });
    }

    render() {
        const { username, password, loading, error } = this.state;

        return (
            <div>
            <div className="background-img-login" />
            <div className="container-fluid">
                <div className="row">
                    <div className="background-white login-window padding-3">
                        <div className="text-center pb3">
                            <img
                                className="img-responsive"
                                role="presentation"
                                src="images/logo-title-dark.png"
                            />
                        </div>

                        <TextField
                            onChange={(event, value) => this.setState({ username: value })}
                            value={username || ''}
                            hintText="Nombre de Usuario"
                            fullWidth
                            errorText={username === '' && 'Usuario requerido'}
                        />

                        <TextField
                            onChange={(event, value) => this.setState({ password: value })}
                            value={password || ''}
                            hintText="Contraseña"
                            type="password"
                            fullWidth
                            errorText={password === '' && 'Contraseña requerida'}
                            onKeyPress={(event) => event.key === 'Enter' && this.login()}
                        />

                        <div className="text-center pt1" style={{ position: 'relative' }}>
                            {
                                loading ?
                                    <RefreshIndicator
                                        size={40}
                                        left={-20}
                                        top={10}
                                        status="loading"
                                        style={{ marginLeft: '50%' }}
                                    /> :
                                    <FlatButton
                                        label="Entrar"
                                        style={{ color: '#737980' }}
                                        onTouchTap={() => this.login()}
                                    />
                            }
                        </div>
                        <p style={{ color: 'red' }}>
                            {error}
                        </p>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./containers/login/index.js